import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useState, useEffect } from "react";
import { getBackend } from "../../api/backend";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { fetchWithCache } from "../../utils/cacheUtils";

const MachineTypeTaskClasses = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [machineTypes, setMachineTypes] = useState({});
  const [MachineTypeTaskClasses, setMachineTypeTaskClasses] = useState({});

  const fieldsConfig = [
    { 
      key: "uuid", 
      label: "Placeholder", 
      type: "text",
      displayForm: false,
      displayList: false
    },
    {
      key: "task_class",
      label: "Clase de Tarea",
      type: "select",
      options: MachineTypeTaskClasses,
      required: true,
      displayForm: true,
      displayList: true
    },
    {
      key: "machine_type",
      label: "Tipo de maquina",
      type: "select",
      options: machineTypes,
      required: true,
      displayForm: true,
      displayList: true
    },
  ];

  const fetchFormInfo = async () => {
    setIsLoading(true);
    
    try {
      // Use fetchWithCache for machine types
      const tempMachineTypes = await fetchWithCache('machineTypes', 
        () => getBackend("machine_types"));
      
      // Use fetchWithCache for task classes
      const temptaskclasses = await fetchWithCache('taskClasses', 
        () => getBackend("task_classes"));
      
      // Process the data as before
      setMachineTypes(
        Object.fromEntries(
          tempMachineTypes.map((item) => [
            item.uuid,
            `${item.type} ${item.subtype} ${item.subsubtype}`,
          ])
        )
      );
      
      setMachineTypeTaskClasses(
        Object.fromEntries(
          temptaskclasses.map((item) => [item.uuid, item.task_class])
        )
      );
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFormInfo();
  }, []);

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Tipos de tareas de maquinas
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList
          fields={fieldsConfig}
          tableName="machine_type_task_classes"
          hasCheckbox={true}
          objectName={"machine type task class"}
          tabledescription={"Tipos de tareas de maquinas"}
        />
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default MachineTypeTaskClasses;
